import React, { Component } from 'react';
const dfp = evite.dfp;

export default class slideshowSideAd extends React.Component {
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.postId !== this.props.postId) {
      googletag.cmd.push(function() {
        googletag.pubads().refresh([window.slideshowSideAd]);
      });
    }
  }
  componentDidMount() {
    if (window.slideshowSideAd) {
      googletag.cmd.push(function() {
        googletag.pubads().refresh([window.slideshowSideAd]);
      });
    } else {
      googletag.cmd.push(function() {
        window.slideshowSideAd = googletag.defineSlot(
          dfp.compactUrl(dfp.DESKTOP_ID, dfp.DESKTOP_SLOT_3, dfp.DESKTOP_SLOT_2, 'photos'),
          [[300, 253]],
          "div-gpt-slideshow-side-ad"
        )
        .setTargeting('loc', 'rr_photos')
        .addService(googletag.pubads());
        googletag.display('div-gpt-slideshow-side-ad');
      });
    }
  }
  render() {
    return (
      <div className="slideshow-side-ad">
        <p className="ad-label"><span>paid advertisement</span></p>
        <div id="div-gpt-slideshow-side-ad" className="gpt-ad"></div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/slideshow/components/slideshow-side-ad.es6